// 転換率 row labels emitted by the BE 年間マッチング数 table (performance-detail-matching-stats.service).
// Must byte-match the BE `MATCHING_CONVERSION_RATES[*].label` strings — the annual table filters
// rows by label, so a mismatch makes a rate row leak through the 転換率を表示 toggle or vanish.
export const CONVERSION_RATE_LABELS = ["推薦前転換率", "推薦転換率", "面接転換率", "内定転換率", "内定受諾転換率"];
